import React, { FC } from 'react';
import { AdditionalLeadListContentProps } from './AdditionalLeadListContent';
import {
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
  DataRowHeader,
  DataRowContent, Wrapper, HeadlineWrapper, EditIconWrapper, EditIcon,
} from './AdditionalListContentUI';
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils/DateUtils';
import { Headline6 } from '../general/Text';

export const LeadContent: FC<AdditionalLeadListContentProps> = (props) => {
  const { lead, users, customers, products, isLeadDetails } = props;

  const findUser = (id: string) => {
    const user = users.find((user) => user.id === id) || null;
    let result = '';
    if (user) {
      result = `${user.firstName} ${user.familyName}`;
    } else {
      result = 'Benutzer nicht gefunden.';
    }

    return result;
  };

  const findCustomer = (id: string) => {
    const customer = customers.find((customer) => customer.id === id) || null;
    let result = '';
    if (customer) {
      result = customer.name;
    } else {
      result = 'Kunde nicht gefunden.';
    }

    return result;
  };

  const findProduct = (id: string) => {
    const product = products.find((product) => product.id === id) || null;
    let result = '';
    if (product) {
      result = product.name;
    } else {
      result = 'Produkt nicht gefunden.';
    }

    return result;
  };

  const editRoute = '/leads/{id}';

  return (
    <Wrapper>
      <HeadlineWrapper>
        <Headline6>Allgemeine Informationen</Headline6>
        {
          isLeadDetails &&
          <EditIconWrapper>
            <Link to={editRoute.replace('{id}', lead.id)}>
              <EditIcon icon={'forwarding'} size={22} />
            </Link>
          </EditIconWrapper>
        }
      </HeadlineWrapper>
      <DataWrapper>
        <DataRow>
          <DataRowHeader>Übermittelt von:</DataRowHeader>
          <DataRowContent>{findUser(lead.senderId)}</DataRowContent>
        </DataRow>
        <AdditionalItemDivider />
        <DataRow>
          <DataRowHeader>Übermittelt an:</DataRowHeader>
          <DataRowContent>{findUser(lead.receiverId)}</DataRowContent>
        </DataRow>
        <AdditionalItemDivider />
        <DataRow>
          <DataRowHeader>Kunde:</DataRowHeader>
          <DataRowContent>{findCustomer(lead.customerId)}</DataRowContent>
        </DataRow>
        <AdditionalItemDivider />
        <DataRow>
          <DataRowHeader>Übermittelt am:</DataRowHeader>
          <DataRowContent>{formatDate(lead.createdAt)}</DataRowContent>
        </DataRow>
        <AdditionalItemDivider />
        <DataRow>
          <DataRowHeader>Produkt:</DataRowHeader>
          <DataRowContent>{findProduct(lead.productId)}</DataRowContent>
        </DataRow>
        <AdditionalItemDivider />
      </DataWrapper>
    </Wrapper>
  );
};
